module.exports = __webpack_public_path__ + "img/ECU.86c0774a.png";